import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { DisbursementBankCodeEnum, DisbursementMethodEnum, DisbursementStatusEnum } from "../../data/enums";

export namespace MarketingDisbursementValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const ClaimRecord = defineValidation(
        defineRecordSchema({
            filters: v.object({
                method: v.optional(v.picklist(DisbursementMethodEnum.values)),
                status: v.optional(v.picklist(DisbursementStatusEnum.values)),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            method: v.picklist(DisbursementMethodEnum.values),
            amount: baseVals.intMin(10000, "Jumlah"),
            notes: v.optional(baseVals.stringEmptiable()),
            xendit: v.optional(
                v.object({
                    bankCode: v.picklist(DisbursementBankCodeEnum.values),
                    accountHolder: baseVals.string(),
                    accountNumber: baseVals.string(),
                }),
            ),
            otp: v.optional(baseVals.string()),
        }),
    );

    export const CalculateFee = defineValidation(
        v.object({
            amount: baseVals.intMin(0, "Jumlah"),
        }),
    );

    export namespace API {
        export const Record = defineValidation(BaseRecordSchema);

        export const CalculateFee = defineValidation(
            v.object({
                method: v.picklist(DisbursementMethodEnum.values),
                amount: baseVals.intMin(10000, "Jumlah"),
            }),
        );
    }
}
